import { gql } from '@apollo/client';
import { apolloClient } from '../config/apollo-client';

// GraphQL query for fetching all environments
export const GET_ALL_ENVIRONMENTS_QUERY = gql`
  query GetAllEnvironments {
    environments {
      id
      name
      host
    }
  }
`;

// Types for the response
export interface Environment {
  id: number;
  name: string;
  host: string;
}

export interface GetAllEnvironmentsResponse {
  environments: Environment[];
}

// GetAllEnvironments service class
export class GetAllEnvironmentsService {
  private static instance: GetAllEnvironmentsService;

  private constructor() {}

  public static getInstance(): GetAllEnvironmentsService {
    if (!GetAllEnvironmentsService.instance) {
      GetAllEnvironmentsService.instance = new GetAllEnvironmentsService();
    }
    return GetAllEnvironmentsService.instance;
  }

  // Fetch all environments
  async getAllEnvironments(): Promise<Environment[]> {
    try {
      const { data } = await apolloClient.query<GetAllEnvironmentsResponse>({
        query: GET_ALL_ENVIRONMENTS_QUERY,
        fetchPolicy: 'network-only',
      });
      return data.environments;
    } catch (error: any) {
      console.error('Error fetching environments:', error);
      if (error.graphQLErrors) {
        error.graphQLErrors.forEach((err: any) => {
          console.error('GraphQL Error:', err.message);
          console.error('Locations:', err.locations);
          console.error('Path:', err.path);
        });
      }
      if (error.networkError) {
        console.error('Network Error:', error.networkError);
      }
      throw error;
    }
  }
}

// Export singleton instance
export const getAllEnvironmentsService =
  GetAllEnvironmentsService.getInstance();

// Export convenience function
export async function getAllEnvironments(): Promise<Environment[]> {
  return getAllEnvironmentsService.getAllEnvironments();
}
